import { Button, ButtonProps } from '@material-ui/core';

export const ButtonWithoutPropagation = ({
  onClick,
  ...props
}: ButtonProps) => {
  return (
    <Button
      {...props}
      onClick={(e) => {
        e.stopPropagation();
        e.preventDefault();
        if (onClick) {
          onClick(e);
        }
      }}
    />
  );
};
